/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { XsoarAccountMappingDto } from './XsoarAccountMappingDto';
import {
    XsoarAccountMappingDtoFromJSON,
    XsoarAccountMappingDtoFromJSONTyped,
    XsoarAccountMappingDtoToJSON,
    XsoarAccountMappingDtoToJSONTyped,
} from './XsoarAccountMappingDto';

/**
 * 
 * @export
 * @interface XsoarAccountMappingResponse
 */
export interface XsoarAccountMappingResponse {
    /**
     * 
     * @type {XsoarAccountMappingDto}
     * @memberof XsoarAccountMappingResponse
     */
    data?: XsoarAccountMappingDto;
    /**
     * 
     * @type {string}
     * @memberof XsoarAccountMappingResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof XsoarAccountMappingResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof XsoarAccountMappingResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof XsoarAccountMappingResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the XsoarAccountMappingResponse interface.
 */
export function instanceOfXsoarAccountMappingResponse(value: object): value is XsoarAccountMappingResponse {
    return true;
}

export function XsoarAccountMappingResponseFromJSON(json: any): XsoarAccountMappingResponse {
    return XsoarAccountMappingResponseFromJSONTyped(json, false);
}

export function XsoarAccountMappingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): XsoarAccountMappingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : XsoarAccountMappingDtoFromJSON(json['data']),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function XsoarAccountMappingResponseToJSON(json: any): XsoarAccountMappingResponse {
    return XsoarAccountMappingResponseToJSONTyped(json, false);
}

export function XsoarAccountMappingResponseToJSONTyped(value?: XsoarAccountMappingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': XsoarAccountMappingDtoToJSON(value['data']),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

